import Input from '@components/Input';
import { useValidatePhoneNumberMutation } from '@shared/services/users';
import ReactUseFormPhoneInput from 'react-phone-number-input/react-hook-form-input';
import { useTranslation } from 'next-i18next';
import { toCamelCase } from '@utilities/helpers/common';

const PhoneInput = ({ name, country, required, ...props }) => {
  const [validatePhoneNumber] = useValidatePhoneNumberMutation();
  const { t } = useTranslation(['common']);
  return (
    <ReactUseFormPhoneInput
      name={name}
      rules={{
        required,
        validate: required && {
          isValid: async (phone) =>
            validatePhoneNumber(phone)
              .unwrap()
              .catch(({ data: { response } }) =>
                t(toCamelCase(response), { ns: 'common' })
              ),
        },
      }}
      label={t('mobile', { ns: 'common' })}
      international
      country={country.toUpperCase()}
      withCountryCallingCode
      inputComponent={Input}
      {...props}
    />
  );
};

PhoneInput.defaultProps = {
  country: 'DK',
  required: true,
};

export default PhoneInput;
